"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Symbols = void 0;
var Symbols;
(function (Symbols) {
    Symbols["INFINITY"] = "\u221E";
    Symbols["EUR"] = "\u20AC";
    Symbols["USD"] = "$";
    Symbols["GBP"] = "\u00A3";
})(Symbols = exports.Symbols || (exports.Symbols = {}));
